/*
 * Hoteliers.com
 * 209
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_209
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {

    const isLogged = false;

    return isLogged;

  };

  /**
     * @memberOf module:bs_209
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    const pathname = window.location.pathname;
    const hostname = window.location.hostname;

    const isGr8Hotels = thn.inArray(thn.data.accountUserId, [1038435, 1034606]);
    const isConferentiehotelKontaktDerKontinenten = thn.data.propertyId === 1026823;
    const isHotelDeDraak = thn.data.propertyId === 1015718;
    const isBlueNijmegen = thn.data.propertyId === 1027222;
    const isLandgoedDuinKruidberg = thn.data.propertyId === 1034149;
    const isHotelFranq = thn.data.propertyId === 1034470;
    const isHotelMidi33 = thn.data.accountUserId === 1032990;
    const isKapellerputConference = thn.data.propertyId === 1037043;
    const isPostllonHotels = hostname.match(/www.postillionhotels.com/);

    return new Promise(function (resolve, reject) {
      let lang;
      if (isHotelMidi33) {
        lang = pathname.match(/^\/flat-hotel\/flat-hotel-(\w{2}).html$/);
        lang = lang && lang.length > 1 && lang[1];
      }

      if (isConferentiehotelKontaktDerKontinenten
                && !pathname.match(/\/bookings\/$/)) {
        lang = window.FWP_HTTP && window.FWP_HTTP.lang;
      }

      if (isGr8Hotels) {
        lang = pathname.slice(1, 3);
      }

      if (isHotelDeDraak
                && !hostname.match(/engine/) && hostname === 'www.hoteldedraak.nl') {
        lang = window.location.pathname.match(ctx.urlRe)[1];
      }

      if (isBlueNijmegen && !pathname.match(/\/hoteliers\/$/)) {
        const pageLang = pathname.match(ctx.urlRe);
        lang = pageLang[1].toLowerCase();
      }

      // Landgoed Duin & Kruidberg - pID : 1034149
      if (isLandgoedDuinKruidberg) {
        const pageLang = document.querySelector('.language-switcher-locale-url .active a')?.getAttribute('xml:lang');
        lang = pageLang;
      }

      // Hotel FRANQ - pID : 1034470
      if (isHotelFranq) {
        const pageLang = document.querySelector('.lang-item.current-lang a')?.textContent;
        lang = pageLang;
      }

      if (isKapellerputConference) {
        const pathLang = pathname.slice(1, 3);
        lang = pathLang === '' ? 'nl' : pathLang;
      }

      if (isPostllonHotels) {
        const pageLang = document.documentElement.lang;
        lang = pageLang === '' ? 'nl' : document.querySelector('#site-language')?.textContent?.toLowerCase();
      }

      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      reject('no_language');
    });
  };

  /**
     *
     * @memberOf module:bs_209
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot(ctx) {

    // Some hotels do not refresh when we change th language so we have to force to refresh the script.
    // Berghotel - pID : 1029081
    const container = document.documentElement;
    if (container) {
      const langRefreshPage = thn.debounce(thn.languageCheck, 800);

      thn.observeDom(container, langRefreshPage, {
        childList: true,
        subTree: false,
        attributes: false,
      });

      thn.shutdown(() => {
        langRefreshPage.cancel();
        thn.stopObserveDom(container, langRefreshPage);
      });
    }

    if (thn.isIframed()) {

      // [iframe] When iframe script, dispatch a message to the parent (we're now inside IBE)

      window.parent.postMessage({ action: 'thn_page_unload' }, '*');

    } else {

      // [parent] Observe to detect the injection of the iframe (IBE)
      //
      // Observe the body for child addition/removal
      // Our target here is an iframe whose ID changes everytime it gets created,
      // so just compare the first part of the id (ex. 'fancybox-container-n', being 'n'
      // the number of times it's been created.

      const iframeObserver = function (mutations) {
        let updateFunction;
        let hoteliersContent;
        const idMatch = /fancybox-(container-|loading|frame)/;

        Array.from(mutations).forEach(function (mutation) {
          Array.from(mutation.addedNodes).forEach(function (node) {
            if (!node.id || typeof node.id !== 'string' || !node.id.match(idMatch)) {
              return;
            }
            // Remove the previous observer
            if (thn.removeHoteliersObserver) {
              thn.removeHoteliersObserver();
              delete thn.removeHoteliersObserver;
            }
            // Build a new observer
            updateFunction = thn.debounce(thn.pageCheck, 400);
            hoteliersContent = node.childNodes[0];

            // if '.fancybox-container-n' is visible this is a "Booking Iframe" page
            thn.observeDom(hoteliersContent, updateFunction, {
              childList: false,
              subtree: false,
              characterData: false,
              attributes: true,
              attributesFilter: ['class'],
            });
            // First time it fires, check the page to get to the `Booking Iframe'
            updateFunction();
            thn.removeHoteliersObserver = function removeHoteliersObserver() {
              thn.stopObserveDom(hoteliersContent, updateFunction);
            };
          });

          // When the iframe is removed, check the page again to return to the previous one.
          // This IBE can be opened from multiple places on the website (Index, Rooms Page..),
          // so, we gotta check where we're at the moment everytime we close the IBE.
          Array.from(mutation.removedNodes).forEach(function (node) {
            if (!node.id || typeof node.id !== 'string' || (!node.id.match(idMatch)
                            && !node.classList.contains('fancybox-overlay'))) {
              return;
            }
            thn.pageCheck();
          });
        });
      };

      thn.observeDom(document.getElementsByTagName('body')[0], iframeObserver, {
        childList: true,
        subtree: true,
        characterData: false,
      });

      thn.shutdown(function () {
        thn.stopObserveDom(document.getElementsByTagName('body')[0], iframeObserver);
      });
    }
  };

  /**
     * @memberOf module:bs_209
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // Example: https://engines.hoteliers.com/en/34/booking/getdata/arrival/18-08-2023/departure/20-08-2023/persons/1/?_ga=2.137653616.1960007902.1690896305-1897307627.1690896305&_gl=1%2A5voia7%2A_gcl_au%2AMTIxMjQzOTEyMS4xNjkwODk2MzA2%2A_ga%2AMTg5NzMwNzYyNy4xNjkwODk2MzA1%2A_ga_N2Y6H8PJ8F%2AMTY5MDk1NzU1NS40LjAuMTY5MDk1NzU5MC4yNS4wLjA.
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/booking/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    url.pathname = url.pathname.replace(/^\/(\w{2}\/)/, `/${ctx.data.language}/`);
    url.pathname = url.pathname.replace(/\/(arrival|departure|persons)\/[^/]+/g, '');

    if (!url.pathname.endsWith('/')) {
      url.pathname += '/';
    }

    if (ctx.data.dateBegin && ctx.data.dateEnd) {
      const arrival = ctx.data.dateBegin.replace(/(\d+)[/.-](\d+)[/.-](\d{2,4})/, '$3-$2-$1');
      url.pathname += `arrival/${arrival}`;
      const departure = ctx.data.dateEnd.replace(/(\d+)[/.-](\d+)[/.-](\d{2,4})/, '$3-$2-$1');
      url.pathname += `/departure/${departure}`;
    }

    const guests = (ctx.data.roomsDispo?.[0]?.adults || 2) + (ctx.data.roomsDispo?.[0]?.children || 0);
    url.pathname += `/persons/${guests}`;

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     *
     * Implements **noRooms**.
     *
     * @memberOf module:bs_209
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates - Depending on the booking page, the IDs may defer
    if (window.wlp && window.wlp.dateArrival && window.wlp.dateDeparture) {
      widgetData.dateBegin = window.wlp.dateArrival.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = window.wlp.dateDeparture.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    } else if (document.querySelector('#arrivaldate, #arrival-date') && document.querySelector('#departuredate, #departure-date')) {
      widgetData.dateBegin = document.querySelector('#arrivaldate, #arrival-date').value.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = document.querySelector('#departuredate, #departure-date').value.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }

    // Rooms
    widgetData.rooms = 1;

    // Guests
    // If no guests selected, every hotel has a different default guest quantity
    const defaultGuests = document.querySelector('#elementForm > div.js-listing--available-items li')?.textContent;
    widgetData.adults = thn.parseNumber(document.querySelector('#persons')?.value) || thn.parseNumber(document.querySelector('#elementForm > div.js-listing--available-items li')?.textContent)
    || (defaultGuests && thn.parseNumber(defaultGuests)) || thn.parseNumber(document.querySelector('.js-rates__wrapper')?.getAttribute('data-persons')) || 2;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Price
    const priceEls = (!thn.empty(document.querySelectorAll('.listing__price')) && document.querySelectorAll('.listing__price'))
    || (!thn.empty(document.querySelectorAll('.js-open-prices-and-slider .alpha')) && document.querySelectorAll('.js-open-prices-and-slider .alpha'));
    const prices = !thn.empty(priceEls) && [...priceEls].map((el) => thn.parseNumber(el.textContent));
    const currency = thn.parseCurrency(priceEls[0]?.textContent);

    if (!thn.empty(prices) && currency) {
      widgetData.currency = currency || thn.parseCurrency(window.wlp?.selectedCurrency);

      widgetData.price = Math.min(...prices);

      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     *
     * @memberOf module:bs_209
     *
     */
  engine._roomDetailsParseData = function roomDetailsParseData() {
    const roomDetailsArray = [];

    // Dates - We need to get the dates because the price of each room is the total and we need to divide it by night.
    let dateBegin;
    let dateEnd;
    if (window.wlp && window.wlp.dateArrival && window.wlp.dateDeparture) {
      dateBegin = window.wlp.dateArrival.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      dateEnd = window.wlp.dateDeparture.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    } else if (document.querySelector('#arrivaldate, #arrival-date') && document.querySelector('#departuredate, #departure-date')) {
      dateBegin = document.querySelector('#arrivaldate, #arrival-date').value.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      dateEnd = document.querySelector('#departuredate, #departure-date').value.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }
    const nights = thn.daysBetween(dateBegin, dateEnd);

    // Rooms
    const roomSelector = [...document.querySelectorAll('[class*=-available-items] [data-type="room"], [class*=-available-items] [data-elementtype="rooms"]')];
    if (roomSelector) {
      roomSelector.forEach(function (element) {
        const typeRoomSelector = {
          Suite: /suite/i,
          Comfort: /comfort/i,
          Deluxe: /deluxe/i,
          Small: /small/i,
          Medium: /medium/i,
          Large: /large/i,
        };
        const roomName = (element.querySelector('h2[class*=room-name]') || {}).innerText;
        const roomType = (Object.keys(typeRoomSelector).filter((key) => ((roomName)).match(typeRoomSelector[key]))[0] || 'Standard');
        const roomId = element.getAttribute('data-id') || element.getAttribute('element_id') || '';
        const roomAdults = thn.parseNumber((element.querySelector('#persons, li') || {}).textContent) || 2;
        const pricesInfo = [...element.querySelectorAll('.js-rates, .js-listing__room-rate')];
        const roomData = {
          id: roomId,
          name: roomName,
          adults: roomAdults,
          children: 0,
          prices: [],
        };
        roomData.type = roomType;
        if (pricesInfo) {
          pricesInfo.forEach(function (priceUnit) {
            const nonRefundableText = /(Non refundable)/i;
            const priceItemName = (priceUnit.querySelector('[class*=rate-name]') || {}).textContent;
            const priceId = priceUnit.getAttribute('data-id') || priceUnit.querySelector('.expander--rate').getAttribute('rate_id') || '';
            const priceBreakfast = (priceUnit.querySelector('[class*=breakfast-description]') || {}).textContent;
            const price = (thn.parseNumber((priceUnit.querySelector('.m-rates__item--price div:not(.strikethrough)') || {}).textContent) || '');
            const priceData = {
              id: priceId,
              name: priceItemName,
              totalNight: price && nights ? price / nights : '',
              breakfast: priceBreakfast.match(/include/i) ? 1 : 0,
              refundable: priceItemName.match(nonRefundableText) ? 0 : 1,
            };
            roomData.prices.push(priceData);
          });
          roomDetailsArray.push(roomData);
        }
        return roomData;
      });
    }
    return roomDetailsArray;
  };

  /**
     * Implements **bookingId**.
     *
     * @memberOf module:bs_209
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    // Check jQuery
    if (!$) {
      return widgetData;
    }

    const $selector = $('.confirmation__subheader.no-print');
    const $nightsSelector = $('.confirmation__row--nights-booked');
    const $transactionId = $('#transaction_bookingid');

    if ($selector.length) {
      if (thn.widgets.price.data.dateBegin && thn.widgets.price.data.dateEnd) {
        widgetData.dateBegin = thn.widgets.price.data.dateBegin;
        widgetData.dateEnd = thn.widgets.price.data.dateEnd;
      } else if ($nightsSelector.length) {
        const dates = $nightsSelector.text().match(/(\d+)-(\d+)-(\d+)/g);
        widgetData.dateBegin = dates.length ? dates[0].replace(/(\d+)\D+(\d+)\D+(\d+)/, '20$3/$2/$1') : undefined;
        widgetData.dateEnd = dates.length > 1 ? dates[1].replace(/(\d+)\D+(\d+)\D+(\d+)/, '20$3/$2/$1') : undefined;
      }

      widgetData.bookingId = thn.parseNumber($('.confirmation__bookingnumber').eq(0).text().trim());
      let $priceSelector = $('div.confirmation__row--total .h-single-line');
      if ($priceSelector.length) {
        // Get the total price from the last row.
        // The hotel may apply some discounts, and they are listed
        // always above the total price, with the same exact class.
        // ---------------------------
        // Own website discount:    9% (this may exists, or not..)
        // Total:                   $224 <--- This one!
        $priceSelector = $priceSelector[$priceSelector.length - 1].textContent;
        widgetData.price = thn.parseNumber($priceSelector);
      }
      widgetData.currency = thn.getCurrencyCode($('div.h-single-line')[0].textContent.match(/[^\d\s,.]+/)[0]);
    }

    if ($transactionId.length) {
      widgetData.bookingId = $transactionId.val();
      widgetData.price = $('#transaction_totalpricewithtaxes') && $('#transaction_totalpricewithtaxes').val();
      widgetData.currency = $('#transaction_currency') && $('#transaction_currency').val();
      widgetData.dateBegin = $('#transaction_checkin_date') && ($('#transaction_checkin_date').val() || '').replace(/-/g, '/');
      widgetData.dateEnd = $('#transaction_checkout_date') && ($('#transaction_checkout_date').val() || '').replace(/-/g, '/');
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_209
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {
    const $ = window.jQuery;

    ctx.promocode = ($ && $('.js-promotion_code-input').val()) || '';

    return ctx.promocode;
  };

  return engine;

}

export { factory };
